// Seguridad en paginas si no te has logueado

import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { revokeUnacknowledgedServerSession, buildLoginRedirectTarget } from "../utils/browserSessionGuard";
import { isSessionAcknowledged } from "../utils/sessionGate";
import { clearSessionKeys } from "../utils/sessionKeys";
import { fetchSessionStatus } from "../utils/sessionAuth";

const PrivateRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;

    const verifyAuth = async () => {
      try {
        if (!isSessionAcknowledged()) {
          await revokeUnacknowledgedServerSession();
          return;
        }

        const session = await fetchSessionStatus();

        if (cancelled) {
          return;
        }

        if (session.authenticated) {
          setIsAuthenticated(true);
          return;
        }

        clearSessionKeys();
      } catch (_) {
        /* auth check failed, isAuthenticated stays false */
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    verifyAuth();
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) return <div>Cargando...</div>;

  if (!isAuthenticated) {
    const redirectTo = buildLoginRedirectTarget(location.pathname, location.search) || "/login";
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default PrivateRoute;
